/**
 * V2 Filter selection
 * One or two single-select groups. A card stays visible when it includes every
 * selected id. The id "all" is ignored. Clicking the active chip clears that group.
 * Choosing a chip covers the cards that remain with a 1s shimmer.
 */
(function () {
  const SECTION_SELECTOR = '[data-v2-pill-filters-selection]';
  const LOADING_MS = 1000;

  function readGroup(root, name) {
    const active = root.querySelector('[data-filter-group="' + name + '"] .v2-pill-filters-selection__chip.is-active');
    if (!active) return [];
    const id = active.getAttribute('data-filter');
    return id ? [id] : [];
  }

  function tagsOf(card) {
    return (card.getAttribute('data-filters') || '')
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function init(root) {
    if (!root || root.dataset.v2PillFiltersSelectionReady === 'true') return;
    root.dataset.v2PillFiltersSelectionReady = 'true';

    const state = {
      primary: readGroup(root, 'primary'),
      secondary: readGroup(root, 'secondary'),
    };

    let timer = 0;

    function apply(showLoading) {
      const applied = state.primary.concat(state.secondary).filter(function (id) {
        return id && id !== 'all';
      });
      const cards = root.querySelectorAll('[data-v2-pill-filters-card]');

      window.clearTimeout(timer);

      cards.forEach(function (card) {
        const tags = tagsOf(card);
        const match = applied.length === 0 || applied.every(function (id) {
          return tags.indexOf(id) !== -1;
        });

        card.hidden = !match;

        if (showLoading && match) {
          card.classList.add('is-loading');
          card.setAttribute('aria-busy', 'true');
        } else {
          card.classList.remove('is-loading');
          card.removeAttribute('aria-busy');
        }
      });

      if (showLoading) {
        timer = window.setTimeout(function () {
          cards.forEach(function (card) {
            card.classList.remove('is-loading');
            card.removeAttribute('aria-busy');
          });
        }, LOADING_MS);
      }
    }

    function setPressed(groupEl, button) {
      const chips = groupEl.querySelectorAll('.v2-pill-filters-selection__chip');
      chips.forEach(function (chip) {
        const on = chip === button;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (event) {
      const button = event.target.closest('.v2-pill-filters-selection__chip');
      if (!button || !root.contains(button)) return;

      const groupEl = button.closest('[data-filter-group]');
      if (!groupEl) return;

      const name = groupEl.getAttribute('data-filter-group');
      if (name !== 'primary' && name !== 'secondary') return;

      const id = button.getAttribute('data-filter');
      const wasActive = button.classList.contains('is-active');

      if (wasActive) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
        state[name] = [];
      } else {
        setPressed(groupEl, button);
        state[name] = id ? [id] : [];
      }

      apply(true);
    });

    apply(false);

    root._v2PillFiltersSelectionDestroy = function () {
      window.clearTimeout(timer);
      delete root.dataset.v2PillFiltersSelectionReady;
    };
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(init);
  }

  initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (root && typeof root._v2PillFiltersSelectionDestroy === 'function') {
      root._v2PillFiltersSelectionDestroy();
    }
  });
})();
